import { createContext, useState } from "react";

export const GroupContext = createContext({
    currentGroup:null,
    setCurrentGroup:()=>null,
    level:0,
    setCurrentLevel:()=>null,
});

export const GroupProvider = ({children})=>{
    const [currentGroup,setCurrentGroup] = useState(JSON.parse(localStorage.getItem('groupLL'))?.group || null);
    const [level,setLevel] = useState(JSON.parse(localStorage.getItem('groupLL'))?.level || 0);
    const value = {currentGroup,setCurrentGroup,level,setLevel};

    return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>
}